import { IAgentCard, EAgentCardAccountType } from '../../types/agentCard';

export function isRentDepartment({ accountType }: IAgentCard) {
  return accountType === EAgentCardAccountType.RentDepartment;
}
